<section id="okta-custom-wrap">
  <div class="okta-custom-wrap-container">
    @if (isLoading) {
      <div>
      </div>
    } @else {
      @if (isAuthenticated) {
        <div>
          <!-- display nothing -->
          IS AUTHENTICATED
        </div>
      } @else {
        <div>
          <div class="okta-custom-message text-center py-20">
            {{'login.errors.message' | translate}}
          </div>
          <div class="text-center">
            <button class="btn btn--primary mr-10" (click)="retry()">{{'login.errors.retry' | translate}}</button>
          </div>
        </div>
      }
    }

  </div>
</section>
